import * as React from 'react';
import {
  LoadingIndicator,
  Table,
  TableFooter,
  TablePaginationNew,
  TablePaginationSizeNew,
  TableContextProvider,
  Search,
} from 'lib/components';

import { NoOptOuts } from './components/NoOptOuts';
import { useQueryOptOuts } from 'lib/api/optouts/queryOptOuts';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Flex, MainWrapper } from 'lib/components/styles/layout';
import { Typography } from 'react-covideo-common';

export interface IOnPaginationChange {
  page: number;
  size: number;
}

export const OptOuts = () => {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);

  const start = page * size;
  const paginationParams = {
    start,
    limit: size,
  };

  const { data, isLoading } = useQueryOptOuts({ search, ...paginationParams });
  const contacts = data?.optOutContacts || [];
  const count = data?.count || 0;
  const { t } = useTranslation();

  const onPaginationChange = ({
    page: newPage,
    size: newSize,
  }: IOnPaginationChange) => {
    if (newSize !== size) {
      // When page size changes, reset to first page to avoid out-of-bounds data
      setSize(newSize);
      setPage(0);
    } else if (newPage !== page) {
      // Only update page when it actually changes
      setPage(newPage);
    }
  };

  const onSearchChangeHandler = async (search: string = '') => {
    setSearch(search);
    setPage(0);
  };

  const isEmptyWithoutSearch = !isLoading && !contacts.length && !search;
  const isEmptySearchResult = !isLoading && !contacts.length && !!search;
  const hasData = !!contacts.length;

  return (
    <Container>
      <MainWrapper resetPadding={false}>
        <Flex flexDirection='column' width='100%'>
          {!isEmptyWithoutSearch && (
            <Search
              width='300px'
              placeholder={t('Search Contacts...')}
              onSearch={onSearchChangeHandler}
              disabled={isLoading}
              extendedStyles={{ wrapper: { marginBottom: '32px' } }}
            />
          )}

          {isLoading && (
            <LoadingIndicator
              isLoading
              text={t('Loading Opt-Outs...')}
              height={400}
            />
          )}

          {isEmptyWithoutSearch && <NoOptOuts />}

          {isEmptySearchResult && (
            <Typography
              variant='normal'
              style={{ margin: '36px 0' }}
              align='center'
              fontWeight={'bold'}
            >
              {t('No matching results found')}
            </Typography>
          )}

          {hasData && (
            <TableContextProvider
              total={count}
              onChange={onPaginationChange}
              initPage={page}
              initSize={size}
            >
              <Table
                compact
                headers={['', t('Email'), t('Opt-Out Date'), '']}
                hoverable={false}
                rows={contacts.map(contact => ({
                  key: contact.contactId,
                  columns: [
                    '',
                    contact.email,
                    new Date(contact.dateOpted).toDateString(),
                    '',
                  ],
                  onClick: () => {},
                }))}
                isLoading={isLoading}
              />

              {count > 0 && (
                <TableFooter>
                  <TablePaginationNew />
                  <TablePaginationSizeNew />
                </TableFooter>
              )}
            </TableContextProvider>
          )}
        </Flex>
      </MainWrapper>
    </Container>
  );
};
